document.addEventListener("DOMContentLoaded", () => {

    let forms = document.querySelectorAll( '.gform_wrapper' );

    if( forms ){
        forms.forEach( form => {

            let firstPage = form.querySelector( '.gform_page:first-of-type' );
            let container = form.querySelector( 'form' );

            if(firstPage){

                if( "none" == firstPage.style.display) return;

                let heading = document.createElement('H2');
                heading.className = 'form_cta';
                heading.innerText = 'Tell us about your project and we\'ll connect you with the authorised A-Line Distributor (Registered Builder) for your local area.'

                container.prepend(heading)

            }
            
        });
    }

} );